// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__32TXy","notes":"Notes_notes__UUAoR"};